import type { UserSettingsToneColors } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.entities";

/** Tone numbers used for coloring; `0` is the neutral tone. */
export type ToneNumber = 0 | 1 | 2 | 3 | 4;
export type HanziScript = "traditional" | "simplified";
export type ToneColorScheme = "light" | "dark";

export const TONE_COLOR_LIGHT_HEX_FIELD_DICT = {
  0: "tone0ColorLightHex",
  1: "tone1ColorLightHex",
  2: "tone2ColorLightHex",
  3: "tone3ColorLightHex",
  4: "tone4ColorLightHex",
} satisfies Record<ToneNumber, keyof UserSettingsToneColors>;

export const TONE_COLOR_DARK_HEX_FIELD_DICT = {
  0: "tone0ColorDarkHex",
  1: "tone1ColorDarkHex",
  2: "tone2ColorDarkHex",
  3: "tone3ColorDarkHex",
  4: "tone4ColorDarkHex",
} satisfies Record<ToneNumber, keyof UserSettingsToneColors>;

export type ToneColorHexField =
  | (typeof TONE_COLOR_LIGHT_HEX_FIELD_DICT)[ToneNumber]
  | (typeof TONE_COLOR_DARK_HEX_FIELD_DICT)[ToneNumber];
